import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AppCa from "./AppCa";
import { getPortal } from "./portals/portalConfig";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "./styles/custom.scss";
import "./styles/index.css";
import { ProvideSnackbarContext } from "./contexts/Snackbar";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { posthogConfig, rollbarConfigV2 } from "./Utils";
import { PostHogProvider } from "posthog-js/react";

const ErrorDisplay = (
  { error, resetError }: { error: Error | null; resetError: () => void } // <-- props passed to fallbackUI component
) => (
  <div>
    <h1>Error</h1>
    <div>{error?.toString()}</div>
    <br />
    <div>
      <a
        style={{ color: "blue" }}
        href="/receptionist"
        onClick={() => localStorage.clear()}
      >
        Go to home page
      </a>
    </div>
  </div>
);

ReactDOM.render(
  <React.StrictMode>
    <Provider config={rollbarConfigV2}>
      <PostHogProvider
        apiKey={posthogConfig.apiKey}
        options={posthogConfig.options}
      >
        <ErrorBoundary fallbackUI={ErrorDisplay}>
          <ProvideSnackbarContext>
            {getPortal() === "ca" ? <AppCa /> : <App />}
          </ProvideSnackbarContext>
        </ErrorBoundary>
      </PostHogProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
